import "./MandatoryInfo.css";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

const MandatoryInfo = (props) => {
  return (
    <div className="d-flex flex-column flex-lg-row mb-5">
      <div className="mandatory-info-number m-3">{props.index}</div>
      <div className="p-3">
        <h2 className="mandatory-info-heading">{props.title}</h2>
        <BlocksRenderer
          content={Array.isArray(props?.text) ? props.text : []}
          blocks={{
            image: ({ image }) => (
              <img
                src={image.url}
                alt={image.alternativeText}
                className="w-100"
              />
            ),
            list: ({ children, format }) =>
              format === "unordered" ? (
                <ul className="blocks-renderer-ul">{children}</ul>
              ) : (
                <ol className="blocks-renderer-ol">{children}</ol>
              ),
            link: ({ children, url }) => (
              <a href={url} style={{ wordBreak: "break-all" }}>
                {children}
              </a>
            ),
          }}
        ></BlocksRenderer>
      </div>
    </div>
  );
};
export default MandatoryInfo;

